<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_xvii"></a><a id="int"></a>Introduction</h2>
<p class="para">The road to success as an author can indeed be a bit challenging. There are so many aspects to authoring, publishing and marketing your book that it’s easy for you to make critical mistakes that can take you off course and significantly decrease your chances for success. When you learn to avoid the biggest mistakes authors make you can greatly enhance your chances for success in the publishing world.</p>
<p class="indent-para">In this insider’s look at the worlds of publishing and book marketing coauthors Rick Frishman, Bret Ridgway and Bryan Hane bring their combined 65 years of experience in the publishing world to you and share their secrets to success. You’ll learn:</p>
<p class="bull1"><span class="bu">•</span> How to master media and other key marketing channels authors should use</p>
<p class="bull"><span class="bu">•</span> Keys to capturing the browsing buyer in bookstores and online</p>
<p class="bull"><span class="bu">•</span> The new publishing landscape and how it impacts you</p>
<p class="bull"><a id="page_xviii"></a><span class="bu">•</span> How to increase the readability of your book so readers keep coming back</p>
<p class="bull"><span class="bu">•</span> How your book is the key piece of your own information marketing empire</p>
<p class="bull"><span class="bu">•</span> And much, much more</p>
<p class="indent-para1">In all you’ll find 50 key mistakes that authors make covered in this book. You’ll learn not only about the book creation process, but also book marketing, the various publishing models, the business behind your book and more. We’ll suggest various resources that can greatly benefit you as an author if you want to take your success to the next level.</p>
<p class="indent-para">Maybe you want to write a book to inspire others. Or maybe your reason is to teach others some specific tactics and strategies about your area of expertise. Regardless of your reason your story should be heard.</p>
<p class="indent-para">Without a doubt every business owner should have a book. Nothing establishes you as an expert in your niche more quickly than being the author of a book. It doesn’t matter whether you’re a chiropractor, lawyer, plumber, mortgage broker, butcher, baker or candlestick maker. Being an author is simply a “must have” in your marketing arsenal.</p>
<p class="indent-para">We wish you the greatest of success as an author and are pleased to provide you this resource to help you down the path. And we hope we’ll cross paths with you at one of our Author 101 University live events sometime in the future.</p>
<p class="indent-para">All our best,</p>
<p class="indent-para">Rick, Bret and Bryan</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?0c9bb787